import React, { useCallback, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useLocale } from '../../locale/LocaleContext';
import './FileSelector.scss';
const supportedFileFormats = ['text/csv', 'text/plain'];
export const FileSelector = ({ onSelected }) => {
    const onSelectedRef = useRef(onSelected);
    onSelectedRef.current = onSelected;
    const [unsupportedFileFormat, setUnsupportedFileFormat] = useState(false);
    const dropHandler = useCallback((acceptedFiles) => {
        // silently ignore if nothing to do
        if (acceptedFiles.length < 1) {
            return;
        }
        const file = acceptedFiles[0];
        if (!supportedFileFormats.includes(file.type))
            return setUnsupportedFileFormat(true);
        onSelectedRef.current(file);
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: dropHandler
    });
    const l10n = useLocale('fileStep');
    const errorBlock = () => {
        return (React.createElement("div", { className: "CSVImporter_FileSelector--error" },
            l10n.unsupportedFileFormatError,
            ". ",
            l10n.activeDragDropPrompt));
    };
    return (React.createElement("div", Object.assign({ className: "CSVImporter_FileSelector", "data-active": !!isDragActive }, getRootProps()),
        React.createElement("input", Object.assign({}, getInputProps())),
        isDragActive ? (React.createElement("span", null, unsupportedFileFormat ? errorBlock() : l10n.activeDragDropPrompt)) : (React.createElement("span", null, unsupportedFileFormat ? errorBlock() : l10n.initialDragDropPrompt))));
};
